import React, { useCallback, useEffect, useState } from 'react'
import OrganizationItem from './OrganizationItem';
import AddOrgBox from './AddOrgBox';
import { useSelector } from 'react-redux';
import { Autocomplete, Button, Dialog, DialogContent, DialogContentText, DialogTitle, Slide, TextField } from '@mui/material';
import { ClubAPI } from '../../../api/ClubAPI';
import PopUpAlert from '../../../component/PopUpAlert';
import Loader from "../../../component/Loader.jsx";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});




const AddOraganization = () => {
  document.title = "Add Org";
  // const clubs = useSelector((store) => store.user.userInfo.clubs);
  const userId = useSelector((store) => store.user.userInfo.userId);
  const [clubs, setClubs] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [clubsList, setClubsList] = useState([]);
  const [club, setClub] = useState({ label: null, id: null });
  const [message, setMessage] = useState({ type: '', content: '', id: '' });
  const [isLoading, setIsLoading] = useState(false);

  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 500);
    };
  };
  const getAllClub=async()=>{
    try {
      setIsLoading(true);
      const response=await ClubAPI.fetchAllClubsByUser(userId);
      setClubs(response.Data);
    } catch (error) {
      
    }finally{
      setIsLoading(false);
    }
  }

  const handleAutocomplete = async (event) => {
    if (!event.target.value?.trim()) {
      setClubsList("");
      setClub("");
      return;
    }

    const clubName = {
      clubName: event.target.value?.trim()
    }
    if (clubName?.clubName?.length < 3) return;
    const response = await ClubAPI.fetchAllClubs(clubName)
    const clubArray = []
    response?.Data?.forEach(item => {
      clubArray.push({ label: item.clubName, id: item.clubId })
    })
    setClubsList(clubArray)
  };
  const optimizedSearch = useCallback(debounce(handleAutocomplete), []);
  const handleSendRequest = async () => {
    try {
      if (club?.id == null) {
        setMessage({ type: 'error', content: 'Please select a organization', id: Date.now() });
        return;
      }
      if (clubs.some(data => data.clubId === club.id)) {
        setMessage({ type: 'error', content: 'You already registered in this organization', id: Date.now() })
        return;
      }
      setIsLoading(true);
      await ClubAPI.sendClubJoinRequest({
        userId: userId,
        clubId: club.id
      });
      getAllClub();
      setOpenPopup(false);
      setMessage({ type: 'success', content: 'Join request sent successfully to the organization', id: Date.now() })
    } catch (error) {
      setMessage({ type: 'error', content: 'Something went wrong', id: Date.now() })
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(()=>{
    if(userId){
      getAllClub()
    }
  },[userId])
  return (
    <div className='sm_organization_details_container'>
      {isLoading && <Loader />}
      <PopUpAlert message={message.content} type={message.type} id={message.id} />
      <h1>Your Organizations</h1>
      <div className='sm_organization_details_list'>
        {
          clubs?.map((club, index) =>
            <OrganizationItem key={index} club={club} />
          )
        }
        <AddOrgBox onClick={() => setOpenPopup(true)} />
      </div>
      <Dialog
        open={openPopup}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setOpenPopup(false)}
      >
        <DialogTitle sx={{ fontFamily: 'sans-serif', fontWeight: 600, textAlign: 'center' }}>{"Organization Join Request"}</DialogTitle>
        <DialogContent sx={{
          width: '30vw',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 3
        }}>
          <Autocomplete
            sx={{ width: '80%', paddingTop: 2 }}
            fullWidth
            value={club?.id ? club : ""}
            onChange={(event, newValue) => setClub(newValue)}
            name="organization"
            disableClearable={true}
            options={clubsList || []}
            renderInput={(params) => (
              <TextField
                className="signup-text-input "
                {...params}
                value={club || ""}
                // error={errors.club}
                placeholder="Enter at least three characters."
                // helperText={errors.club && "Please Select Club"}
                onChange={optimizedSearch}
                label="Organization"
              />
            )}
          />
          <div className='sm_organization_send_req_btn'>
            <Button
              onClick={handleSendRequest}
              sx={{
                backgroundColor: 'var(--hoverColorBold)',
                color: 'white',
                borderRadius: 2,
                '&:hover': {
                  backgroundColor: 'var(--hoverColorBold)',
                }
              }}>Send Request</Button>

            <Button
              onClick={() => setOpenPopup(false)}
              sx={{
                backgroundColor: 'orangered',
                color: 'white',
                borderRadius: 2,
                '&:hover': {
                  backgroundColor: 'orangered',
                }
              }}>cancel</Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default AddOraganization